/**
 * Mock practitioner data for testing and development (enriched)
 */
export const mockPractitioners = [
  {
    id: 'wulei',
    username: 'wulei',
    name: '吴磊',
    gender: 'Male',
    age: 45,
    title: '院长/中医古法调理专家',
    education: '硕士',
    certifications: ['执业医师证', '中医针灸证书'],
    experienceYears: 22,
    workHistory: [
      { organization: '国保中医调理中心', title: '院长', from: '2018', to: 'Present' },
      { organization: '中联华国际中医针灸研究院', title: '调理专家', from: '2010', to: '2018' }
    ],
    honors: ['雏英高飞项目创始人'],
    avatarUrl: '/assets/images/wulei.png',
    phoneNumber: '13900139001',
    email: 'wulei@tcmcenter.com',
    specialties: ['青少年增高', '古法拨筋', '穴位灸'],
    bio: '擅长通过古法拨筋导引加秘方穴位灸贴，调理脾胃及五脏六腑，安全高效，见效快。',
    languages: ['Chinese'],
    consultationFee: '500元/次',
    tags: ['青少年增高', '古法调理', '脾胃调理'],
    wechat: 'wulei_tcm',
    address: '北京市朝阳区中医调理中心',
    scheduleNote: '需提前预约',
    isExpert: true,
    sortOrder: 1,
    isActive: true,
    availability: [
      { dayOfWeek: 1, startTime: '09:00', endTime: '17:00', isRecurring: true },
      { dayOfWeek: 3, startTime: '09:00', endTime: '17:00', isRecurring: true },
      { dayOfWeek: 5, startTime: '09:00', endTime: '17:00', isRecurring: true }
    ]
  },
  {
    id: 'wangwenzhong',
    username: 'wangwenzhong',
    name: '王文中',
    gender: 'Male',
    age: 68,
    title: '原中央军委保健局局长',
    education: '本科',
    certifications: ['主任医师证'],
    experienceYears: 40,
    workHistory: [
      { organization: '中央军委保健局', title: '局长', from: '2000', to: '2020' }
    ],
    honors: ['中国健康促进基金会第三届理事长'],
    avatarUrl: '/assets/images/wangwenzhong.png',
    phoneNumber: '13900139002',
    email: 'wangwz@tcmcenter.com',
    specialties: ['高层保健', '健康管理'],
    bio: '长期负责党和国家高层领导保健医疗服务管理，经验丰富。',
    languages: ['Chinese'],
    consultationFee: '1000元/次',
    tags: ['高层保健', '健康管理'],
    wechat: '',
    address: '北京市',
    scheduleNote: '',
    isExpert: true,
    sortOrder: 2,
    isActive: true,
    availability: [
      { dayOfWeek: 2, startTime: '10:00', endTime: '16:00', isRecurring: true }
    ]
  },
  {
    id: 'lixitao',
    username: 'lixitao',
    name: '李锡涛',
    gender: 'Male',
    age: 72,
    title: '国医大师/教授',
    education: '博士',
    certifications: ['国医大师证书'],
    experienceYears: 50,
    workHistory: [
      { organization: '清华大学深圳国际研究生院', title: '杰出实践教授', from: '2010', to: 'Present' }
    ],
    honors: ['中医基因学创始人'],
    avatarUrl: '/assets/images/lixitao.png',
    phoneNumber: '13900139003',
    email: 'lixitao@tcmcenter.com',
    specialties: ['中医理论', '体质辨识'],
    bio: '全国名老中医，国医大师，擅长中医体质辨识和个性化调理。',
    languages: ['Chinese'],
    consultationFee: '1200元/次',
    tags: ['中医理论', '体质辨识'],
    wechat: '',
    address: '深圳市',
    scheduleNote: '',
    isExpert: true,
    sortOrder: 3,
    isActive: true,
    availability: [
      { dayOfWeek: 4, startTime: '09:00', endTime: '15:00', isRecurring: true }
    ]
  },
  {
    id: 'wangzhiguo',
    username: 'wangzhiguo',
    name: '王志国',
    gender: 'Male',
    age: 55,
    title: '主任医师/博士生导师',
    education: '博士',
    certifications: ['主任医师证'],
    experienceYears: 30,
    workHistory: [
      { organization: '中国中医科学院', title: '主任医师', from: '2005', to: 'Present' }
    ],
    honors: ['中医学博士生导师'],
    avatarUrl: '/assets/images/wangzhiguo.png',
    phoneNumber: '13900139004',
    email: 'wangzg@tcmcenter.com',
    specialties: ['肾病', '肺病', '三高'],
    bio: '肾、肺、三高诊疗专家，著名中医内科、皮肤科专家。',
    languages: ['Chinese'],
    consultationFee: '800元/次',
    tags: ['肾病', '三高', '内科'],
    wechat: '',
    address: '北京市',
    scheduleNote: '',
    isExpert: true,
    sortOrder: 4,
    isActive: true,
    availability: [
      { dayOfWeek: 5, startTime: '13:00', endTime: '18:00', isRecurring: true }
    ]
  },
  {
    id: 'liuyong',
    username: 'liuyong',
    name: '柳勇',
    gender: 'Male',
    age: 60,
    title: '研究员',
    education: '博士',
    certifications: ['研究员证书'],
    experienceYears: 40,
    workHistory: [
      { organization: '陕西省科学院微生物研究所', title: '研究员', from: '1985', to: 'Present' }
    ],
    honors: ['多项国家发明专利'],
    avatarUrl: '/assets/images/liuyong.png',
    phoneNumber: '13900139005',
    email: 'liuyong@tcmcenter.com',
    specialties: ['食药用菌', '抗癌药研发'],
    bio: '食药用菌研究40年，参与及独立开发抗癌药和功能性产品近百种。',
    languages: ['Chinese'],
    consultationFee: '600元/次',
    tags: ['食药用菌', '抗癌药'],
    wechat: '',
    address: '西安市',
    scheduleNote: '',
    isExpert: true,
    sortOrder: 5,
    isActive: true,
    availability: []
  },
  {
    id: 'quanshaojie',
    username: 'quanshaojie',
    name: '权少洁',
    gender: 'Male',
    age: 58,
    title: '资深中医专家/主治医师',
    education: '本科',
    certifications: ['主治医师证'],
    experienceYears: 38,
    workHistory: [
      { organization: '和睦家医院', title: '特聘专家', from: '2010', to: 'Present' },
      { organization: '世界杰出华商协会', title: '定期诊疗调理专家', from: '2015', to: 'Present' }
    ],
    honors: ['医术高超，医德高尚'],
    avatarUrl: '/assets/images/quanshaojie.png',
    phoneNumber: '13900139006',
    email: 'quanshaojie@tcmcenter.com',
    specialties: ['中医内科', '针灸', '妇科'],
    bio: '从事中医药临床诊疗近40年，擅长中医内科、针灸、妇科。',
    languages: ['Chinese'],
    consultationFee: '700元/次',
    tags: ['中医内科', '妇科', '针灸'],
    wechat: '',
    address: '北京',
    scheduleNote: '',
    isExpert: true,
    sortOrder: 6,
    isActive: true,
    availability: []
  },
  {
    id: 'xiedaiqing',
    username: 'xiedaiqing',
    name: '谢代清',
    gender: 'Male',
    age: 50,
    title: '中医世家/火神派传人',
    education: '本科',
    certifications: ['中医师证'],
    experienceYears: 38,
    workHistory: [
      { organization: '李锡涛教授门下', title: '火神派传人', from: '2000', to: 'Present' }
    ],
    honors: ['临床经验丰富，疗效奇佳'],
    avatarUrl: '/assets/images/xiedaiqing.png',
    phoneNumber: '13900139007',
    email: 'xiedaiqing@tcmcenter.com',
    specialties: ['治未病', '疑难杂症', '药食同源调理'],
    bio: '中医世家第5代，擅于"治未病"调理身体阴阳平衡及治疗疑难杂症，特长药食同源饮食调理。',
    languages: ['Chinese'],
    consultationFee: '600元/次',
    tags: ['治未病', '疑难杂症', '药食同源'],
    wechat: '',
    address: '北京',
    scheduleNote: '',
    isExpert: true,
    sortOrder: 7,
    isActive: true,
    availability: []
  },
  {
    id: 'wangweidong',
    username: 'wangweidong',
    name: '汪卫东',
    gender: 'Male',
    age: 56,
    title: '失眠/焦虑/抑郁诊疗专家',
    education: '博士',
    certifications: ['主任医师证'],
    experienceYears: 30,
    workHistory: [
      { organization: '北京中医药大学', title: '教授', from: '2000', to: 'Present' },
      { organization: '中国中医科学院广安门医院', title: '原副院长', from: '2010', to: '2018' }
    ],
    honors: ['世界中医药学会联合会中医心理学专委会会长'],
    avatarUrl: '/assets/images/wangweidong.png',
    phoneNumber: '13900139008',
    email: 'wangweidong@tcmcenter.com',
    specialties: ['失眠', '焦虑', '抑郁', '中医心理'],
    bio: '擅长失眠、焦虑、抑郁等心理及睡眠问题的中医诊疗。',
    languages: ['Chinese'],
    consultationFee: '900元/次',
    tags: ['失眠', '焦虑', '抑郁', '心理'],
    wechat: '',
    address: '北京',
    scheduleNote: '',
    isExpert: true,
    sortOrder: 8,
    isActive: true,
    availability: []
  }
];

export default mockPractitioners; 